import './InvoiceEditorHeading.scss';

import * as React from 'react';
import { generateDangerHTMLFromText } from '../../../Other/Translation';

export interface InvoiceEditorHeadingPropsInterface {
  branding: string;
  brandingDetails: string;
  logoLinkUrl: string;
}

export const InvoiceEditorHeading: React.FC<InvoiceEditorHeadingPropsInterface> =
  ({ logoLinkUrl, brandingDetails, branding, children }) => {
    return (
      <div className="Header">
        <div className="navbar">
          <div className="branding">
            <a target="_parent" rel="noopener noreferrer" href={logoLinkUrl}><div className="logo" /></a>
            <div className="description">{branding}</div>
            <div className="details" dangerouslySetInnerHTML={generateDangerHTMLFromText(brandingDetails)} />
          </div>
          <div className="buttons">
            {children}
          </div>
        </div>
      </div>
    );

  };

export default InvoiceEditorHeading;
